import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import dayjs from "dayjs";
import { fetchImageAsBase64 } from "../../../../../../../utils/imageUtils";


//APP
import { imgLogo } from "../../../../../../../utils/base64-Imgs";
import { typeEstruturaTodasAtvs } from "./estrutura_todas_atvs";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

export interface HeaderDef {
    logo: string;
    titulo: string;
    razaoSocial: string;
    cliente?: string;
    autor?: string;
}

export const gerarDocDefinition = (
    dados: typeEstruturaTodasAtvs[],
    incluir_insumos: boolean,
    incluir_patrimonios: boolean,
    headerInfo?: HeaderDef
) => {
    const content: any[] = [];

    // Header Principal (Somente Primeira Página)
    content.push({
        stack: [
            {
                image: headerInfo?.logo || 'imgLogoAlias',
                width: 80,
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                text: `${headerInfo?.titulo}`,
                style: 'headerMain',
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 760,
                        h: 4,
                        linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                    }
                ],
            },
            {
                stack: [
                    {
                        text: `${headerInfo?.razaoSocial}`,
                        fontSize: 8,
                        bold: true,
                        color: '#4D4D4D',
                        alignment: 'center'
                    },
                    ...(headerInfo?.cliente ? [{
                        text: `Cliente: ${headerInfo.cliente}`,
                        fontSize: 13,
                        bold: true,
                        color: '#000000',
                        alignment: 'center',
                        margin: [0, 10, 0, 0]
                    }] : [])
                ],
                margin: [0, 5, 0, 20]
            }
        ],
        margin: [0, 0, 0, 10]
    });

    dados.forEach((propriedade) => {
        // Header Propriedade
        content.push({
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            text: propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA",
                            style: 'headerPropriedade',
                            alignment: 'center',
                            fillColor: '#5da57d',
                            color: 'white',
                            bold: true,
                            margin: [0, 5, 0, 5]
                        }
                    ]
                ]
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0]
        });

        propriedade.lista_atividades_por_talhao.forEach((talhao) => {
            // Header Talhao
            content.push({
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: talhao.nome_talhao || "TALHÃO NÃO INFORMADO",
                                style: 'headerTalhao',
                                alignment: 'center',
                                fillColor: '#fff',
                                color: '#165c13',
                                bold: true,
                                margin: [2, 2, 2, 2],
                                border: [true, true, true, true]
                            }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#165c13',
                    vLineColor: () => '#165c13'
                },
                margin: [0, 0, 0, 0]
            });

            let globalAtvIndex = 0; // Para controle de zebra por bloco lógico
            const corHeader = '#0e743f';
            const bodyAtividades: any[] = [
                // Table Header Atividades
                [
                    { text: 'Atividade', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                    { text: 'Operação', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                    { text: 'Datas', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                    { text: 'Área', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                    { text: 'Área executada', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' },
                    { text: 'Concluída', style: 'tableHeader', alignment: 'center', fillColor: corHeader, color: 'white' }
                ]
            ];

            talhao.lista_atividades.forEach((atv) => {

                const formatarData = (dInicio: string | null, dFim: string | null) => {
                    if (!dInicio && !dFim) return '-';
                    const i = dInicio ? dayjs(dInicio).format("DD/MM/YY") : '?';
                    const f = dFim ? dayjs(dFim).format("DD/MM/YY") : '?';
                    if (i === f) return i;
                    return `${i} - ${f}`;
                };

                const dataStr = formatarData(atv.data_inicio, atv.data_final);
                const descLen = (atv.descricao || '-').length;
                const extraLines = Math.max(Math.ceil(descLen / 34) - 1, 0);
                const offset = extraLines * 6;

                const zebraColor = (globalAtvIndex % 2 === 0) ? null : '#e5f1e1';

                bodyAtividades.push([
                    { text: atv.descricao || '-', margin: [0, 8, 0, 8], alignment: 'center', fillColor: zebraColor },
                    { text: atv.tipo_operacao || '-', margin: [0, 8 + offset, 0, 8], alignment: 'center', fillColor: zebraColor },
                    { text: dataStr, margin: [0, 8 + offset, 0, 8], alignment: 'center', fillColor: zebraColor },
                    { text: `${atv.area} ha (remonte: ${atv.porcentagem_remonte}%)`, margin: [0, 8 + offset, 0, 8], alignment: 'center', fillColor: zebraColor },
                    { text: `${atv.area_executada} ha (${atv.porcentagem_executada}%)`, margin: [0, 8 + offset, 0, 8], alignment: 'center', fillColor: zebraColor },
                    {
                        text: atv.concluido ? 'SIM' : 'NÃO',
                        fillColor: atv.concluido ? '#01c16c' : zebraColor,
                        color: atv.concluido ? '#fff' : '#000',
                        bold: true,
                        alignment: 'center',
                        margin: [0, 8 + offset, 0, 8]
                    }
                ]);

                if (incluir_insumos || incluir_patrimonios) {

                    const subTables: any[] = [];

                    if (incluir_insumos) {
                        subTables.push({
                            table: {
                                widths: ['*'],
                                body: [[{
                                    text: 'Insumos Planejados',
                                    // fillColor: '#f8f9fa',
                                    bold: true,
                                    fontSize: 10,
                                    margin: [5, 2, 0, 2],
                                    alignment: 'left'
                                }]]
                            },
                            layout: 'noBorders',
                            margin: [0, 5, 0, 2]
                        });

                        if (atv.insumos && atv.insumos.length > 0) {
                            const listaInsumos = atv.insumos.map((insu: any) => {
                                const detalhes = () => {
                                    switch (insu?.cod_tipo) {
                                        case 8:
                                            return `\nTipo: ${insu.nome_tipo || '-'} | Doses: ${insu.doses_inoculante || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | Qtde: ${insu.quantidade_insumo || 0}`;

                                        default:
                                            return `\nTipo: ${insu.nome_tipo || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | Qtde: ${insu.quantidade_insumo || 0}`;
                                    }
                                }
                                return {
                                    text: [
                                        { text: `${insu.insumo_nome || '-'}`, bold: true, fontSize: 10, color: '#2E2E2E' },
                                        { text: detalhes(), fontSize: 9, color: '#4D4D4D' }
                                    ],
                                    margin: [0, 3, 0, 3]
                                };
                            });

                            subTables.push({
                                ul: listaInsumos,
                                margin: [25, 2, 0, 8],
                                alignment: 'left'
                            });
                        } else {
                            subTables.push({
                                text: 'Não possui insumos cadastrados',
                                italics: true,
                                color: '#4D4D4D',
                                fontSize: 9,
                                margin: [25, 0, 0, 10],
                                alignment: 'left'
                            });
                        }
                    }

                    if (incluir_patrimonios) {
                        subTables.push({
                            table: {
                                widths: ['*'],
                                body: [[{
                                    text: 'Patrimônios Planejados',
                                    // fillColor: '#f8f9fa',
                                    bold: true,
                                    fontSize: 10,
                                    margin: [5, 2, 0, 2],
                                    alignment: 'left'
                                }]]
                            },
                            layout: 'noBorders',
                            margin: [0, 2, 0, 2]
                        });

                        if (atv.patrimonios && atv.patrimonios.length > 0) {
                            const listaPatrimonios = atv.patrimonios.map((pat: any) => {
                                const label = pat.horimetro_inicial || pat.horimetro_final ? 'Horímetro' : 'Quilometragem';
                                return {
                                    text: [
                                        { text: `${pat.patrimonio_nome || pat.nome || '-'}`, bold: true, fontSize: 10, color: '#2E2E2E' },
                                        { text: `\n${label} inicial: ${pat.horimetro_inicial ?? pat.quilometragem_inicial ?? '-'} | ${label} final: ${pat.horimetro_final ?? pat.quilometragem_final ?? '-'}`, fontSize: 9, color: '#4D4D4D' }
                                    ],
                                    margin: [0, 3, 0, 3]
                                };
                            });

                            subTables.push({
                                ul: listaPatrimonios,
                                margin: [25, 2, 0, 8],
                                alignment: 'left'
                            });
                        } else {
                            subTables.push({
                                text: 'Não possui patrimônios cadastrados',
                                italics: true,
                                color: '#4D4D4D',
                                fontSize: 9,
                                margin: [25, 0, 0, 10],
                                alignment: 'left'
                            });
                        }
                    }

                    if (subTables.length > 0) {
                        bodyAtividades.push([
                            {
                                colSpan: 6,
                                stack: subTables,
                                margin: [40, 0, 40, 5],
                                fillColor: zebraColor
                            },
                            {}, {}, {}, {}, {}
                        ]);
                    }
                }

                globalAtvIndex++;
            });

            content.push({
                table: {
                    widths: ['25%', '15%', '20%', '10%', '15%', '15%'],
                    body: bodyAtividades
                },
                layout: {
                    fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                        if (rowIndex === 0) return '#a6a6a6'; // Header principal
                        return null;
                    }
                },
                margin: [0, 0, 0, 15]
            });
        });
    });

    return {
        content: content,
        pageOrientation: 'landscape',
        footer: (currentPage: number, pageCount: number) => {
            const dataGeracao = dayjs().format("DD/MM/YYYY, HH:mm:ss");
            return {
                stack: [
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 760,
                                h: 4,
                                linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                            }
                        ],
                        margin: [0, 0, 0, 5]
                    },
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        columns: [
                            {
                                width: '*',
                                stack: [
                                    {
                                        image: 'imgLogoAlias',
                                        width: 50,
                                        margin: [0, 3, 0, 0],
                                    },
                                ],
                                alignment: 'left',
                            },
                            {
                                width: '*',
                                stack: [
                                    {
                                        text: `Gerado por: ${headerInfo?.autor}`,
                                        bold: true,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                    {
                                        text: `${dataGeracao}`,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                ],
                                margin: [0, 3, 0, 0],
                                alignment: 'center',
                            },
                            {
                                width: '*',
                                text: `${currentPage} de ${pageCount}`,
                                alignment: 'right',
                                fontSize: 8,
                                margin: [0, 3, 0, 0],
                                color: '#4D4D4D'
                            },
                        ],
                    },
                    {
                        width: '*',
                        text: `Licenciado para: Agromarques - Consultoria Agronômica e Agricultura de Precisão 24.901.637/0001-17`,
                        alignment: 'left',
                        fontSize: 6,
                        margin: [0, 3, 0, 10],
                        color: '#4D4D4D'
                    },
                ],
                margin: [40, 0, 40, 0],
            };
        },
        images: {
            imgLogoAlias: imgLogo
        },
        styles: {
            headerMain: {
                fontSize: 20,
                bold: true,
                color: 'black'
            },
            headerPropriedade: {
                fontSize: 14,
                bold: true
            },
            headerTalhao: {
                fontSize: 12,
                bold: true
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'white',
                alignment: 'center'
            }
        },
        defaultStyle: {
            fontSize: 10,
            alignment: 'center'
        },
        pageMargins: [40, 40, 40, 60] // Restaurado margem superior padrão
    };
};

export const gerarPdfDataUrl = async (
    dados: typeEstruturaTodasAtvs[],
    incluir_insumos: boolean,
    incluir_patrimonios: boolean,
    headerInfo?: HeaderDef
): Promise<string> => {
    // Se houver uma logo em formato de URL, converte para Base64 antes de gerar o PDF
    if (headerInfo?.logo && headerInfo.logo.startsWith("http")) {
        headerInfo.logo = await fetchImageAsBase64(headerInfo.logo);
    }

    return new Promise((resolve, reject) => {
        try {
            const docDefinition = gerarDocDefinition(dados, incluir_insumos, incluir_patrimonios, headerInfo);
            pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
                resolve(dataUrl);
            });
        } catch (err) {
            reject(err);
        }
    });
};
